<template>
  <div>
    <img :src="posterUrl" alt="" />
    <van-empty description="暂无数据" v-show="noDataFlag" />
  </div>
</template>

<script>
import { getCus as cusGetDict } from "@/api/dictDetail.js";
import Vue from "vue";
import { getWx } from "@/utils/wxJsSdk.js";
import { Empty, Toast } from "vant";

Vue.use(Empty);
export default {
  data() {
    return {
      posterUrl: "",
      noDataFlag: false,
    };
  },

  mounted() {
    this.getQuery();
  },
  created() {},
  methods: {
    getQuery() {
      let id = this.$route.query.id;
      let dictName = this.$route.query.name;
      if (id && dictName) {
        this.getData(id, dictName);
      } else {
        this.noDataFlag = true;
      }
    },
    getData(id, dictName) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      cusGetDict(dictName)
        .then((res) => {
          // 通过传入的id找到字典里的海报图
          let s = res.find((item) => {
            return item.id == id;
          });
          if (s) {
            // 获取分享内容模板
            this.getShareTxt(s.label);
            document.title = s.label;
            this.posterUrl = s.value;
          } else {
            this.noDataFlag = true;
          }
          Toast.clear();
        })
        .catch((err) => {
          Toast.clear();
          console.log("err", err);
        });
    },
    getShareTxt(title) {
      let desc = "点击查看操作流程：" + title;
      let that = this;
      let url = window.location.href;
      getWx().then((res) => {
        window.wx.updateAppMessageShareData({
          title: "办理指引", // 分享标题
          desc: desc, // 分享描述
          link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            "https://static.xchengtech.cn/4a6254f9d27042ddabb8c7d8c766b9bc.png", // 分享图标
          success: function (res) {
            console.log("res", res);
            //afterShare();
          },
        });
      });
    },
  },
};
</script>
<style scoped>
img {
  display: block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/operatingManual/module/posterPage.vue